<template>
  <div
    ref="containerScrollRef"
    class="flex flex-col flex-nowrap flex-1 overflow-x-auto"
  >
    <template
      v-for="alternativa in alternativas"
      :key="alternativa.id"
    >
      <div
        class="grid-cols-opcoes min-h-[--pergunta-height] items-center relative"
        :class="{
          active: respostas?.[alternativa.id],
          'opacity-75 pointer-events-none': isDisabledResposta,
        }"
        :style="{
          '--color':
            respostas?.[alternativa.id]?.respostas?.at(-1)?.cor,
          height: heightAlternativa?.[alternativa.id] || 'auto',
        }"
      >
        <template
          v-for="(itemopcao, index) in alternativa.itemopcao_set"
          :key="itemopcao.id"
        >
          <ItemOptButton
            :style="{
              background: color(
                respostas?.[alternativa.id]?.respostas?.at(-1)?.cor
              ),
            }"
            :color-active="corActive(alternativa, itemopcao)"
            :label="itemopcao.opcao_titulo_readonly"
            :itemopcao
            @click:opt="
              $emit('click:opt', { itemopcao, alternativa, index })
            "
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script setup>
import { inject, onBeforeUnmount, onMounted, ref } from 'vue'
import { returnRGB } from 'js/utils/GLOBAL'
import ItemOptButton from 'components/PagePergunta/ItemOptButton.vue'
import usePerguntas from 'composables/usePerguntas'
/** @typedef {import('js/vue/types/pergunta.ts').Alternativaset[]} Alternativas */

/** @type {{ alternativas: Alternativas }} */
const { respostas } = defineProps({
  alternativas: Object,
  respostas: Object,
  heightAlternativa: Object,
})

const { isDisabledResposta } = usePerguntas()

const emit = defineEmits(['click:opt'])

const color = (cor) => cor && `rgba(${returnRGB(cor)}, 0.1)`

const corActive = (alternativa, itemopcao) => {
  const res = respostas?.[alternativa.id]?.respostas?.find(
    (r) => r.opcao === itemopcao.opcao
  )
  return res ? res.cor : null
}

const containerScrollRef = ref(null)
const headerRef = inject('headerRef')

function syncScroll() {
  headerRef.value.headerRef.scrollLeft =
    containerScrollRef.value.scrollLeft
}

onMounted(() => {
  if (containerScrollRef.value) {
    containerScrollRef.value.addEventListener('scroll', syncScroll)
  }
})

onBeforeUnmount(() => {
  if (containerScrollRef.value) {
    containerScrollRef.value.removeEventListener('scroll', syncScroll)
  }
})
</script>

<style lang="scss"></style>
